const brightcoveBaseURL = "https://players.brightcove.net/2566261597001/i8tIKNh2lm_default/index.html?videoId=";
const searchParams = new URLSearchParams(window.location.search);

const createStyles = () => {
    let brightcoveStyleElement = document.querySelector("#brightcove-styles");
    if (brightcoveStyleElement) return;

    brightcoveStyleElement = document.createElement("style");
    brightcoveStyleElement.setAttribute("id", "brightcove-styles")

    brightcoveStyleElement.textContent = `
        #brightcove-dialog[open] {
            display: grid;
            place-items: center;
            width: 100vw;
            height: 100vh;
            padding: 0;
            border: none;
            background-color: transparent;
        }

        #brightcove-dialog::backdrop {
            background-color: #000b;
        }

        #brightcove-dialog > div {
            width: 90vw;
            aspect-ratio: 16 / 9;
            max-width: 100rem;
            max-height: 85vh;
        }

        #brightcove-dialog iframe {
            display: block;
            width: 100%;
            height: 100%;
            max-height: 70vh;
            margin-bottom: 1rem;
        }

        #brightcove-dialog button {
            color: white;
            background-color: var(--brand-color-orange);
            border: 2px solid white;
            border-radius: 1rem;
            display: block;
            margin: 0 auto;
        }
    `
    document.querySelector("head").appendChild(brightcoveStyleElement);
}

const createBrightcoveModal = (videoId) => {
    createStyles();

    const dialogElement = document.createElement("dialog");
    dialogElement.setAttribute("id", "brightcove-dialog");

    const dialogContentElement = document.createElement("div");

    const closeDialogButton = document.createElement("button");
    closeDialogButton.textContent = "Close Video";

    const iframeElement = document.createElement("iframe");
    iframeElement.setAttribute("frameborder", "0");
    iframeElement.setAttribute("allowfullscreen", "");
    iframeElement.setAttribute("src", brightcoveBaseURL + videoId);

    dialogContentElement.appendChild(iframeElement);
    dialogContentElement.appendChild(closeDialogButton);
    dialogElement.appendChild(dialogContentElement);

    document.body.appendChild(dialogElement);

    dialogElement.showModal();

    const handleDialogClick = (event) => {
        const target = event.target;
        if (target.id === "brightcove-dialog") {
            closeDialog();
        }
    }

    const closeDialog = () => {
        dialogElement.close();
        dialogElement.remove();

        dialogElement.removeEventListener("click", handleDialogClick);
        closeDialogButton.removeEventListener("click", closeDialog);
        window.removeEventListener("keydown", handleEscapeKey);
    }

    const handleEscapeKey = (event) => {
        const key = event.key;
        if (key === "Escape") {
            closeDialog();
        }
    }

    dialogElement.addEventListener("click", handleDialogClick);
    closeDialogButton.addEventListener("click", closeDialog);
    window.addEventListener("keydown", handleEscapeKey);
};

if (searchParams.has("videoId")) {
    createBrightcoveModal(searchParams.get("videoId"));
}
